export default {
    path: '/auth-check-order',
    name: 'Auth-Check-Order',
    component: () => import('@/views/auth/auth-check-order.vue'),
    meta: {
        title: 'Авторизация',
        forVisitors: true
    }
}